import React from 'react';

const Inquiry = () => {
    return ;
}
 
export default Inquiry;